/**
 * @typedef {ReturnType<typeof import('widgets/forms/AjaxForm').default>} AjaxForm
 */

/**
 * @param {AjaxForm} AjaxForm Base widget for extending
 * @returns {typeof NotifyMeForm} NotifyMeForm widget
 */
export default function (AjaxForm) {
    class NotifyMeForm extends AjaxForm {
        prefs() {
            return {
                notifyEmail: 'dwfrm_notifyme_email',
                formButton: 'formButton',
                successMessage: 'successMessage',
                accessibilityAnnouncementMsg: '',
                ...super.prefs()
            };
        }

        /**
         * @description Handles server response
         * @emits "alert.show"
         * @param {object} data Server JSON response once form submitted
         * @returns {void}
         */
        onSubmitted(data) {
            if (data.success) {
                this.ref('formButton').hide();
                this.ref('successMessage')
                    .setText(data.msg)
                    .show();
                /**
                 * @description Global event to show alert
                 * @event "alert.show"
                 */
                this.eventBus().emit('alert.show', {
                    accessibilityAlert: this.prefs().accessibilityAnnouncementMsg
                });
            }

            if (!data.success) {
                if (data.fieldErrors) {
                    Object.entries(data.fieldErrors).forEach(([name, errorMsg]) => {
                        this.getById(name, formField => formField.setError(errorMsg));
                    });
                }
                if (data.msg) {
                    this.getById(this.prefs().notifyEmail, inputEmail => inputEmail.setError(data.msg));
                }
            }
        }
    }

    return NotifyMeForm;
}
